__turbopack_context__.v({
  "desktop": "Asset-module__AtdQiq__desktop",
  "mobile": "Asset-module__AtdQiq__mobile",
  "playToggle": "Asset-module__AtdQiq__playToggle",
  "video": "Asset-module__AtdQiq__video",
  "videoWrap": "Asset-module__AtdQiq__videoWrap",
});
